import { render, staticRenderFns } from "./TagPageSocial.vue?vue&type=template&id=a68345b4&scoped=true"
import script from "./TagPageSocial.vue?vue&type=script&lang=ts"
export * from "./TagPageSocial.vue?vue&type=script&lang=ts"
import style0 from "./TagPageSocial.vue?vue&type=style&index=0&id=a68345b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68345b4",
  null
  
)

export default component.exports